"use client";
import style from '@/assets/styling/scss/stories.module.scss';
import { Story } from '.';
import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0.2, scale: 0.95 }, 
  visible: {
    opacity: 1,
    scale: 1, 
    transition: {
      staggerChildren: 0.05,  
      when: "beforeChildren",
      duration: 0.4,  
    },
  },
};
export default function Stories() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    async function loadStories() {
      try {
        const response = await fetch('/data/stories.json');
        const data = await response.json();
        // Get all stories from the JSON (no hardcoded IDs)
        const storiesDataArray = Object.values(data).filter(Boolean);
        setStories(storiesDataArray);
      } catch (error) {
        console.error('Error loading stories:', error);
      }
    }
    loadStories();
  }, []);

  if (stories.length === 0) return null;

  return (
    <AnimatePresence>
      <motion.section
        className={style.stories}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
      >
        {stories.map(story => (
          <Story key={story.id} {...story} />
        ))}
      </motion.section>
    </AnimatePresence>
  );
}
